import React from 'react';

import ReportTrailsTable from '../Table';

import { useStyles } from './styles';

export default ({ fields }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ReportTrailsTable fields={fields} />
    </div>
  );
};
